import React from "react";
// @ts-ignore
import AppointmentCalendar from "./AppointmentCalendar";
import AppointmentContingents from "./AppointmentContingents";
import AppointmentPrices from "./AppointmentPrices";

interface Props {
    settings: any,
    setSettings: any
}
const Appointment = (props: Props) => {
    const { settings, setSettings } = props;
    return (
        <>
            <form className="off-content row">
                <AppointmentCalendar
                    settings={settings}
                    setSettings={setSettings}
                    key={"vehicleOwnerCalendar"}
                />
                <AppointmentContingents
                    settings={settings}
                    setSettings={setSettings}
                    key={"vehicleOwnerContingents"}
                />
                <AppointmentPrices
                    settings={settings}
                    setSettings={setSettings}
                    key={"vehicleOwnerPrices"}
                />
            </form>
        </>
    );
}

export default Appointment;